export default __webpack_public_path__ + "static/media/CircleMedical.2d806559.svg";